import type { NavItem } from "@/src/components/custom/navigation/custom-sider-nav-group";

export const navGroupCore: NavItem[] = [
  {
    key: "core-home",
    label: "Home",
    route: "/",
  },
  {
    key: "core-athletes",
    label: "Athletes",
    route: "/athletes",
  },
  {
    key: "core-events",
    label: "Datasets",
    route: "/datasets",
  },
  {
    key: "core-moments",
    label: "Moments",
    route: "/moments",
  },
  /*{
    key: "core-predictions",
    label: "Predictions",
  },
  */
  {
    key: "core-visuals",
    label: "Visuals",
  },
];

export const navGroupDistribution = [
  {
    key: "dist-broadcast",
    label: "Broadcast Control",
    route: "/broadcast",
  },
];

export const navGroupAdmin = [
  {
    key: "admin-users",
    label: "Users",
  },
  {
    key: "admin-integrations",
    label: "Integrations",
  },
  {
    key: "admin-account",
    label: "Account",
  },
];
